import { render, staticRenderFns } from "./RoomNo.vue?vue&type=template&id=7068f60e&scoped=true&"
import script from "./RoomNo.vue?vue&type=script&lang=js&"
export * from "./RoomNo.vue?vue&type=script&lang=js&"
import style0 from "./RoomNo.vue?vue&type=style&index=0&id=7068f60e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7068f60e",
  null
  
)

export default component.exports